import { useParams } from 'react-router-dom';
import useHttpQuery from 'data/firestore/useHttpQuery';
import { ACTIONS_BASE_URL, WORKFLOWS_APP_URL } from '../../../../../constants';
import { CellWrapper } from '../../../columns/styled';
import {
    NotFoundContent,
    ResponderName,
    SmallWorkflowIcon,
    StyledWarningIcon,
} from './styled';

interface Props {
    workflowId?: string;
}

const WorkflowCell = ({ workflowId }: Props) => {
    const { agentId } = useParams();
    // eslint-disable-next-line max-len
    const { data: workflowData, isLoading } = useHttpQuery<{ data: { name: string, publishedVersionId: string } }>({
        pathname: `/workflows/${workflowId}`,
        server: ACTIONS_BASE_URL,
        key: ['workflow', workflowId],
        queryOptions: { enabled: Boolean(workflowId) },
    });

    const workflowName = workflowData?.data?.name;
    const workflowPublishedVersionId = workflowData?.data?.publishedVersionId as string;
    const href = agentId && workflowId
        ? `${WORKFLOWS_APP_URL}/agents/${agentId}/workflows/${workflowId}/versions/${workflowPublishedVersionId}/builder`
        : undefined;

    if (!workflowId || (!isLoading && !workflowName)) {
        return (
            <CellWrapper>
                <NotFoundContent>
                    <StyledWarningIcon title="Workflow Not Found" />
                    Workflow Not Found
                </NotFoundContent>
            </CellWrapper>
        );
    }

    if (!workflowName) {
        return <CellWrapper />;
    }

    return (
        <CellWrapper>
            <ResponderName
                as="a"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
            >
                <SmallWorkflowIcon />
                {workflowName}
            </ResponderName>
        </CellWrapper>
    );
};

export default WorkflowCell;
